import { Component, OnInit, inject } from '@angular/core';
import { FormGroup, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-notes-dialog',
  templateUrl: './notes-dialog.component.html',
  styleUrls: ['./notes-dialog.component.scss'],
  imports: [
    MatDialogModule,
    MatCheckboxModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
  ],
})
export class NotesDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<NotesDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  form: FormGroup;
  headline: string;
  content: string;
  confirm: string;
  placeholder: string;
  noteData = { text: null, pinned: false, alert: false };

  ngOnInit() {
    if (this.data) {
      this.headline = this.data.headline || 'Enter a New Note';
      this.content = this.data.content || '';
      this.placeholder = this.data.placeholder || '';
      this.confirm = this.data.confirm || 'Save';
    }
  }

  cancel() {
    this.dialogRef.close({ data: 'cancel' });
  }

  save() {
    if (this.noteData.text) {
      this.dialogRef.close({ data: this.noteData });
      this.dialogRef.afterClosed().subscribe(() => {
        this.dialogRef = null;
      });
    }
  }
}
